(function () {
  if (window.__cardHover) return;
  window.__cardHover = true;

  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  function dir(e, el) {
    var r = el.getBoundingClientRect();
    var dx = (e.clientX - r.left - r.width / 2) / (r.width / 2);
    var dy = (e.clientY - r.top - r.height / 2) / (r.height / 2);
    var horizontal = Math.abs(dx) >= Math.abs(dy);
    // Sweep purely along the dominant axis: a side-to-side move wipes
    // horizontally, a top/bottom (or diagonal) move wipes vertically. The
    // off-axis is pinned to 0% so the wash never drifts toward a corner.
    return {
      x: horizontal ? (dx >= 0 ? "110%" : "-110%") : "0%",
      y: horizontal ? "0%" : dy >= 0 ? "110%" : "-110%",
      horizontal: horizontal,
      sx: dx >= 0 ? 1 : -1,
      sy: dy >= 0 ? 1 : -1,
    };
  }

  function setSkew(card, d, flip) {
    var s = (d.horizontal ? d.sx : d.sy) * (flip ? -1 : 1);
    var deg = s > 0 ? "11deg" : "-11deg";
    card.style.setProperty("--pc-skx", d.horizontal ? deg : "0deg");
    card.style.setProperty("--pc-sky", d.horizontal ? "0deg" : deg);
  }

  function enter(card, e) {
    var d = dir(e, card);
    card.classList.add("pc-no-anim");
    card.classList.remove("is-pc-out", "is-pc-in");
    card.style.setProperty("--pc-tx", d.x);
    card.style.setProperty("--pc-ty", d.y);
    setSkew(card, d, false);
    void card.offsetWidth;
    card.classList.remove("pc-no-anim");
    card.classList.add("is-pc-in");
  }

  function leave(card, e) {
    var d = dir(e, card);
    card.style.setProperty("--pc-ex", d.x);
    card.style.setProperty("--pc-ey", d.y);
    setSkew(card, d, true);
    card.classList.remove("is-pc-in");
    card.classList.add("is-pc-out");
  }

  document.addEventListener("mouseover", function (e) {
    var card = e.target.closest ? e.target.closest(".card") : null;
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    enter(card, e);
  });

  document.addEventListener("mouseout", function (e) {
    var card = e.target.closest ? e.target.closest(".card") : null;
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    leave(card, e);
  });
})();
